import { fetch } from 'utils/fetch';
// 获取申请单详情
export const getCommonDocDetail = (applicationOID = '', recordOID = '') => {
  if (!applicationOID) {
    return;
  }
  return fetch({
    url: `/api/common/document/${applicationOID}`,
    method: 'GET',
  });
};

/**
 * 查询是否有代替单据
 * @param formType  101为申请单，102为报销单，104为借款单   ？？那么103呢
 * @returns {*}
 */
export function getProxyAuth(formType = '101') {
  return fetch({
    url: '/api/custom/forms/my/proxy/customForm',
    method: 'GET',
    params: {
      formType,
    },
    nativeResponseSerializer: 'boolean',
  });
}

/**
 * 查询单据可代理人列表
 * @param formType  101为申请单，102为报销单，104为借款单
 * @returns {*}
 */
export function getMyProxyUsers(formType = '101') {
  return fetch({
    url: '/api/bill/proxy/query/my/principals',
    method: 'GET',
    params: {
      formType,
      userFrom: 'APP',
    },
  });
}

/**
 * 查询是否有代替单据
 * @param formType  101为申请单，102为报销单，104为借款单   ？？那么103呢
 * @returns {*}
 */
export function getProxyAuthAll(formType = null) {
  return fetch({
    url: '/api/custom/forms/my/proxy/customForm',
    method: 'GET',
    params: {
      formType,
    },
    nativeResponseSerializer: 'boolean',
  });
}

/**
 * 查询单据可代理人列表
 * @param formType  101为申请单，102为报销单，104为借款单
 * @returns {*}
 */
export function getMyProxyUsersAll(formType = '') {
  return fetch({
    url: '/api/bill/proxy/query/my/principals',
    method: 'GET',
    params: {
      formType,
      userFrom: 'APP',
    },
  });
}

/**
 * 查询用户可用表单
 * @param userOID undefined也是查本人表单
 * @param formType  101为申请单，102为报销单，104为借款单
 * @param jobId 岗位id，不传则默认主岗
 * @returns {*}
 */
export function getUserAvailableForms(userOID, formType = '101', jobId) {
  return fetch({
    url: '/api/custom/forms/my/available',
    method: 'GET',
    params: {
      userOID,
      formType,
      jobId,
    },
  });
}

/**
 * 设置默认岗位
 * @param userOID undefined也是查本人表单
 * @param formType  101为申请单，102为报销单，104为借款单
 * @param jobId 岗位id，不传则默认主岗
 * @returns {*}
 */
export function defaultUserJobId(userJobId, cancel) {
  return fetch({
    url: `/api/user/jobs/document/default?userJobId=${userJobId}&cancel=${cancel}`,
    method: 'PUT',
  });
}

export function getSubmissionList() {
  return fetch({
    url: 'api/submission/list',
    method: 'POST',
    data: {
      name: '',
    },
  });
}

export function getUserAvailableFormsV2(userOID, documentSubmissionId, businessTypeId, jobId) {
  return fetch({
    url: '/api/v2/custom/forms/my/available',
    method: 'GET',
    params: {
      userOID,
      documentSubmissionId,
      businessTypeId,
      jobId,
    },
  });
}

export function getUserSubmissionHistory(applicantOID, submissionId, applicantJobId) {
  return fetch({
    url: '/api/form/histories/submission',
    method: 'GET',
    params: {
      applicantOID,
      submissionId,
      applicantJobId,
    },
  });
}

// 查询开启对应付款行类型可用的对公支付单表单
export function getCorpDocument(params) {
  return fetch({
    url: '/api/corp/custom/form/my/available',
    method: 'GET',
    params,
  });
}
